var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "cookie-selector"
  }, [_c('div', [_c('p', {
    staticClass: "text-primary"
  }, [_vm._v(" " + _vm._s(_vm.$t("cookie_consent.custom_selection_description")) + " ")])]), _c('div', {
    staticClass: "accordion"
  }, [_c('div', {
    staticClass: "card p-0"
  }, [_c('div', {
    staticClass: "card-header d-flex justify-content-between align-items-center"
  }, [_c('h2', {
    staticClass: "mb-0"
  }, [_c('button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapseNecessary",
      modifiers: {
        "collapseNecessary": true
      }
    }],
    staticClass: "btn btn-link btn-block text-left collapsed",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("cookie_consent.necessary_cookies")) + " ")])]), _vm._m(0)]), _c('b-collapse', {
    attrs: {
      "id": "collapseNecessary",
      "accordion": "cookieAccordion",
      "role": "tabpanel"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_vm._v(" " + _vm._s(_vm.$t("cookie_consent.necessary_cookies_description")) + " ")])])], 1), _c('div', {
    staticClass: "card p-0"
  }, [_c('div', {
    staticClass: "card-header d-flex justify-content-between align-items-center"
  }, [_c('h2', {
    staticClass: "mb-0"
  }, [_c('button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapseAnalytics",
      modifiers: {
        "collapseAnalytics": true
      }
    }],
    staticClass: "btn btn-link btn-block text-left collapsed",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("cookie_consent.analytics_cookies")) + " ")])]), _c('div', {
    staticClass: "custom-control custom-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.analyticsCookies,
      expression: "analyticsCookies"
    }],
    staticClass: "custom-control-input",
    attrs: {
      "type": "checkbox",
      "id": "analyticsCookiesSwitch"
    },
    domProps: {
      "checked": Array.isArray(_vm.analyticsCookies) ? _vm._i(_vm.analyticsCookies, null) > -1 : _vm.analyticsCookies
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.analyticsCookies,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.analyticsCookies = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.analyticsCookies = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.analyticsCookies = $$c;
        }
      }
    }
  }), _c('label', {
    staticClass: "custom-control-label",
    attrs: {
      "for": "analyticsCookiesSwitch"
    }
  })])]), _c('b-collapse', {
    attrs: {
      "id": "collapseAnalytics",
      "accordion": "cookieAccordion",
      "role": "tabpanel"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_vm._v(" " + _vm._s(_vm.$t("cookie_consent.analytics_cookies_description")) + " ")])])], 1)])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "custom-control custom-switch"
  }, [_c('input', {
    staticClass: "custom-control-input",
    attrs: {
      "type": "checkbox",
      "id": "necessaryCookiesSwitch",
      "checked": "",
      "readonly": "",
      "disabled": ""
    }
  }), _c('label', {
    staticClass: "custom-control-label",
    attrs: {
      "for": "necessaryCookiesSwitch"
    }
  })]);

}]

export { render, staticRenderFns }